import script from "./lei-employee.vue?vue&type=script&setup=true&lang=ts"
export * from "./lei-employee.vue?vue&type=script&setup=true&lang=ts"

import "./lei-employee.vue?vue&type=style&index=0&id=66dd64e1&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-66dd64e1"]])

export default __exports__